export const MIN_SEARCH_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 300;
export const SEARCH_PAGE_SIZE = 20;
export const CALL_STATUS_POLL_INTERVAL_MS = 2500;
export const CALL_RING_TIMEOUT_MS = 30000;
export const QR_TOAST_DURATION_MS = 4000;
export const CALL_RECOVERY_TIMEOUT_MS = 15000;
export const CALL_RECOVERY_RETRY_MS = 2000;
export const CALL_RECOVERY_ATTEMPTS = 2;
export const REMOTE_RECONNECT_GRACE_MS = 15000;
export const RTM_CONNECT_TIMEOUT_MS = 5000;
export const RTM_OPERATION_TIMEOUT_MS = 1000;
export const QR_RTM_CONFIG_PROVIDER = 'qrRtmConfig';

export const QR_RTM_COMMAND = {
    DIRECT_REJECT: 'DIRECT_REJECT',
    CALL_ENDED: 'CALL_ENDED',
    CALL_EXPIRE: 'CALL_EXPIRE',
};

export const QR_CALL_STATUS = {
    RINGING: 'ringing',
    ANSWERED: 'answered',
    DECLINED: 'declined',
    MISSED: 'missed',
    ENDED: 'ended',
};

export const QR_CALL_FINAL_STATUSES = [QR_CALL_STATUS.DECLINED, QR_CALL_STATUS.MISSED, QR_CALL_STATUS.ENDED];

export const QR_CALL_STAGE = {
    PRECALL: 'precall',
    CONNECTING: 'connecting',
    RINGING: 'ringing',
    IN_CALL: 'in-call',
    DECLINED: 'declined',
    MISSED: 'missed',
    ENDED: 'ended',
    ERROR: 'error',
};

export const QR_CALL_ERROR = {
    MIC_REQUIRED: 'mic_required',
    LOCATION_REQUIRED: 'location_required',
    START_FAILED: 'start_failed',
    TOKEN_EXPIRED: 'token_expired',
    CONNECTION_LOST: 'connection_lost',
    MEDIA_FAILED: 'media_failed',
};

export const AGORA_CLIENT_CONFIG = { mode: 'rtc', codec: 'vp8' };

export const QR_ENTRANCE_STATUS = {
    IDLE: 'idle',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
};

export const QR_ROUTES = {
    INVALID: 'qr.invalid',
    HOME: 'qr.home',
    LOCATION: 'qr.location',
    SEARCH: 'qr.search',
    CALL: 'qr.call',
};
